import { Components, Theme } from '@mui/material/styles';

export const flowDialogContentText: Components<Theme>['MuiDialogContentText'] = {
  defaultProps: {},
  styleOverrides: {
    root: ({ theme }) => ({
      color: theme.palette.text.primary,
    }),
  },
};
